import { connect } from "react-redux";
import {
    getManifoldMetadata,
    renderUpperManifolds,
    renderLowerManifolds,
    renderMainManifolds, clearBuildGenerationFlag,
} from "../../actions/manifold-actions";
import BaseComponent from "../../lib/base-component";

class ManifoldBuilder extends BaseComponent {
  static watchedProps = [
    'chamberType',
    'chamberRows',
    'chamberEndCapType',
    'chamberRowSpacing',
    'scalePixels',
    'scaleValue',
    'structureDistance',
    'manifoldSize',
    'structureSize',
    'manifoldStructures',
    'sepDistance',
  ];

  onPropHasChanged() {}
}

const mapStateToProps = state => {
    return {
        scaleValue: state.globals.scaleValue,
        numOfRows: state.chamberbed.numOfRows,
        chamberType: state.globals.chamberType,
        isSystemGenerated: state.globals.isSystemGenerated,
        scalePixels: state.globals.scalePixels,
        sepDistance: state.stonebed.sepDistance,
        chamberRows: state.chamberbed.chamberRows,
        numOfChambers: state.chamberbed.numOfChambers,
        manifoldSize: state.calculations.manifoldSize,
        structureSize: state.calculations.structureSize,
        chamberEndCapType: state.globals.chamberEndCapType,
        chamberRowSpacing: state.globals.chamberRowSpacing,
        manifoldStructures: state.stonebed.manifoldStructures,
        structureDistance: state.calculations.structureDistance,
    };
};

const mapDispatchToProps = {
    getManifoldMetadata,
    renderUpperManifolds,
    renderLowerManifolds,
    renderMainManifolds,
    clearBuildGenerationFlag,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ManifoldBuilder);



// WEBPACK FOOTER //
// ./src/components/Builders/manifold-builder.js